export default "__VITE_ASSET__ffcd5324__"